export const es_master = {
    "basket": {
        "sending_to": "Enviando a:",
        "bonus_balance": "Saldo de bonificación",
        "bonus_data": "Datos de bonificación",
        "valid_for": "válido por {{bonusValidity}} días",
        "worth": "<span> Valor de {{faceValue}} {{sourceCurrencyCode}} </ span> <br /> <span> es {{totalLocalCurrencyAmount}} {{currencyCode}} </ span>"
    },
    "login": {
        "register_link": "Registrar como usuario nuevo",
        "reset_password": "Restablecer la contraseña",
        "preceed_to_login": "Proceda a iniciar sesión",
        "link_login": "¿Ya tienes una cuenta? Iniciar sesión",
        "title_account_verify": "Verificación de la cuenta",
        "resend_code": "Reenviar codigo",
        "didnt_receive_code": "No recibió el código? Reenviar ahora.",
        "code_resent": "El código ha sido reenviado",
        "verify_code_label": "Código de verificación",
        "verify_label": "Verificar",
        "reload": "Recargar",
        "remember_me": "¿Recuérdame?",
        'current_password': "Contraseña actual",
        'new_password': "Nueva contraseña",
        'confirm_new_password': "Confirmar nueva contraseña",
        'password_successfully_changed': "Contraseña cambiada con éxito",
        'change_password': "Cambiar contraseña"
    },
    "menu": {
        "dashboard": "Panel de control",
        "operator": "Operador",
        "send_balance": "Enviar recarga",
        'buy_gift_card': 'Comprar Tarjeta de Regalo',
        "auto_balance": "Recarga automática",
        "order_history": "Historial de pedidos",
        "order_summary": "Resumen del pedido",
        "receipt": "Recibo",
        "support": "Apoyo",
        "store_locator": "Localizador de tiendas",
        "logout": "Cerrar sesión",
        "login": "Iniciar sesión",
        "register": "Registrar",
        "number": "Número",
        "order": "Orden",
        "summary": "Resumen",
        "payment": "Pago",
        "verify_code": "Código de verificación",
        'change_password': "Cambia la contraseña",
        "forgot_password": "Se te olvidó tu contraseña",
        "forgot_password_confirm": "Olvidé mi contraseña de confirmación",
        "support_tickets": "Boletos de soporte",
        "reward_points": "Puntos de recompensa",
        "account": "Cuenta",
        "contact_list": "Lista de contactos",
        "stored-cards" : "Tarjetas de crédito guardadas",
        "checkout-as-guest" : "Pagar como invitado",
        "guest-email" : "Correo electrónico de invitado",
        "note":"Nota: las tarjetas asociadas con perfiles recurrentes no se pueden eliminar"
    },
    "home": {
        "welcome": "Bienvenido a eTopup Online"
    },
    "send_balance": {
        "no_country_found": "No se ha encontrado ningún país para los criterios de búsqueda",
        "confirm_password_label": "Confirmar contraseña",
        "password_label": "Contraseña",
        "user_name_label": "Dirección de correo electrónico",
        "signup_button": "Regístrese desde bp",
        "pay_button_title": "Paga",
        "checkout_button_title": "Revisa",
        "next_button_title": "Siguiente",
        "mobile_number_placeholder": "Número de teléfono móvil",
        "credit_card_number": "Número de tarjeta de crédito",
        "from_credit_card": "De la tarjeta de crédito",
        "from_paypal": "De Paypal",
        "from_reward_points": "Desde puntos de recompensa",
        "auto_balance_title": "Establecer recargas automáticas",
        "balance_pending": "Top-up pendiente",
        "repeat_button_title": "REPETIR",
        'repeat_transaction': "Repita la transacción",
        "debit_credit_placeholder": "Tarjeta de crédito",
        "card_number_placeholder": "Numero de tarjeta de Débito / Crédito",
        "expiration_date_placeholder": "Fecha de vencimiento",
        "cvv_placeholder": "CVV",
        "full_name_placeholder": "Nombre completo",
        "billing_address_placeholder": "DIRECCIÓN DE FACTURACIÓN",
        "street_address_placeholder": "Dirección",
        "city_placehoder": "Ciudad",
        "postal_code_placeholder": "Código postal",
        "state_placeholder": "Estado",
        "country_placeholder": "País",
        "find_credit_card_number": "¿DÓNDE PUEDO ENCONTRAR LOS NÚMEROS DE MI TARJETA DE CRÉDITO?",
        "stored_credit_card": "Tarjeta guardada",
        'stored_cc_future': "Tarjeta de crédito almacenada para el futuro",
        "new_card_type": "Nueva tarjeta",
        "select_card_type": "Seleccione tarjeta de crédito o débito",
        "transaction_id": "Transacción: # {{transactionId}}",
        "balance_failed": "La recarga falló",
        "recharge_to": "Recargar a",
        "failed": "ha fallado",
        "pending": "pendiente",
        "check_valid_number_1": "Por favor verifica si es válido",
        "check_valid_number_2": "número e intentar nuevamente",
        "balance_success": "Recarga exitosa",
        "label_trasaction": "Transacción:",
        "incorrect_phone_number": "Su número de teléfono no es correcto. ¡Inténtelo de nuevo!",
        "ok": "DE ACUERDO",
        "view_all_link": "Ver todo",
        "balance_phone_number_label": "Número de teléfono de recarga",
        "exchange_rate_label": "Tipo de cambio",
        "select_amt_label": "Seleccione Cantidad de Recarga",
        "select_operator": "Seleccionar operador",
        "select_sku": "Seleccione Monto",
        "search_country": "Buscar país",
        'click_select_country': 'Haga clic aquí para seleccionar País',
        "select_country": "Por favor seleccione país",
        "select_country_placeholder": "Seleccionar país",
        "enter_mobile_number": "Por favor ingrese el número de celular",
        "operator_missing": "Por favor seleccione el operador.",
        "amount_missing": "Seleccione el monto de recarga.",
        "coupon_code_label": "Código promocional",
        "reward_points_label": "Puntos de recompensa",
        "coupon_apply_label": "Aplicar",
        "coupon_applied_message": "Código de cupón aplicado. Recibirás un descuento de {{discount}} {{currency}}.",
        "cover_sales_tax_message": "Quiero cubrir el impuesto y entregar {{currencyCode}} {{faceValue}} al teléfono",
        "reward_points_message": "Tienes {{reward}} puntos de recompensa ({{discount}} {{currency}}). Puedes usar hasta {{discountTopup}} {{currency}} para este recargo.",
        "zero_amount_payment_message": "¡Felicidades! Tienes un punto de recompensa para pagar esta recarga. No se le cobrará por esta transacción.",
        "paypal_message": "Ha seleccionado Paypal como método de pago. Al hacer clic en Pagar, se le redirigirá al sitio web de Paypal para completar el pago.",
        "payment_sub_heading": "",
        "topup_heading":"Enviar recarga",
        "topup_sub_heading": "Ingrese el número al que le gustaría agregar saldo",
        "viva_disclaimer": "Las recargas en esta aplicación están disponibles para tarjetas de crédito en E.E.U.U. Para uso nacional, República Dominicana, los montos serán facturados en USD.",
        "paypal_conversion_message": "Su transacción de PayPal se procesará en dólares estadounidenses",
        "select_value" : "Seleccione un valor",
        "giftcard_delivery_disclaimer" : "La tarjeta de regalo electrónica se enviará al destinatario por correo electrónico y SMS. Asegúrese de que esta información sea correcta. Esto no se puede cambiar después de la venta.",
        "enter_recipient_details": "Introduzca los detalles del recipiente",
        "recipient_mobile" : "Número móvil del recipiente",
        "recipient_email" : "Correo electrónico del recipiente",
        "confirm_recipient_email" : "Confirmar el correo electrónico del recipiente",
        "recipient_name" : "Nombre completo del recipiente",
        "recipient_message" : "Mensaje al recipiente",
        "sender_details" : "Introduzca los detalles del remitente",
        "sender_mobile": "Número móvil del remitente",
        "sender_name" : "Nombre completo del remitente",
        "gift_card" : "Tarjeta de Regalo",
        "purchase_failed" : "La compra falló",
        "purchase_pending" : "Compra pendiente",
        'purchase-timeout': "Tiempo de espera de compra",
        "reward_code_applied": "Código de recompensa aplicado",
        "enter_reward_code_bak" : "Ingrese el código de recompensa",
        "enter_reward_code" : "ingrese el código de recarga",
        "store_pin_payment_msg" :"¡Felicidades! No se le cobrará por esta transacción. Por favor revise su correo electrónico para ver el recibo."
    },
    "auto_balance": {
        "topup_day": "Día de recarga",
        "signup_button": "Regístrese desde bp",
        "auto_balance_header": "Auto-recargas activas",
        "no_profile_msg": "No hay recarga automática activa disponible. Haga clic en el botón de abajo para crear un nuevo perfil.",
        "new_profile_button_title": "Nueva recarga automática",
        "back_to_home_title": "De vuelta a página de inicio",
        "frequency_30days": "30 dias",
        "frequency_15days": "15 días",
        "frequency_7days": "7 días",
        "week": "Semana",
        "month": "Mes",
        "enable_profile_button_title": "Habilitar recargas automáticas",
        "frequency_label": "Frecuencia",
        "balance_amount_label": "Monto de recarga",
        'auto_balance_cancel_fail': "Lo sentimos. Se produjo un error al cancelar la recarga automática. Por favor, póngase en contacto con atención al cliente",
        "auto_balance_success": "Auto recarga creada con éxito.",
        "auto_balance_cancelled": "La recarga automática se canceló exitosamente",
        "frequency_days": "cada {{frequencyDays}} días",
        "active_auto_topup_status": "{{frequency}} en {{topupDayString}}",
        "terms_and_conditions_msg": "Al proceder al pago está aceptando",
        "terms_and_conditions_link": "Términos y Condiciones",
        "proceed_with_for_payment": "Proceder con",
        "plus_bonus": "+ Bonificación",
        "bonus_data": "& {{bonusData}} DATOS",
        "profile_created": "Recarga automática creada",
        "cancel_message": "¿Seguro que quieres cancelar la recarga automática a número móvil + {{internationalCode}} {{localMobileNumber}}?",
        'schedule': "Programación: Cada {{freq}} en {{topupDayString}} comenzando {{startDateFormated}}. Nota: Puede cancelar la recarga automática en cualquier momento. Ninguna pregunta hecha.",
        'schedule_short': "Cada {{freq}} en {{topupDayString}} a partir de {{startDateFormated}}.",
        'starting': 'Comenzando',
        'contact_number': `Número de contacto del remitente`,
        'contact_number_missing' : 'Por favor, introduzca el número de contacto del remitente.'
    },
    "receipt": {
        "recipient": "Recipiente",
        "price": "Precio",
        "balance": "Monto de recarga",
        "less_tax": "Menos impuestos",
        "bonus_balance": "Recarga de bonificación",
        "bonus_data": "Datos de bonificación",
        "bonus_validity": "Válido para {{bonusValidity}} días",
        "bonus_data_validity": "Bonificación válida para {{bonusValidity}} días",
        "total_balance": "Cantidad total de recarga",
        "total_data": "Datos totales",
        "processing_fee": "Gastos Operativos",
        "total_payment": "Pago total",
        'promo_code_label': "Código promocional",
        'promo_code_applied': 'Código promocional aplicado',
        "promo_code_discount_label": "Descuento (cupón de promoción)",
        "reward_point_discount_label": "Redención del punto de recompensa",
        "sms_charge": "Carga de SMS",
        'send_sms': "Enviar SMS personales",
        'sms_fee': "Se aplica una tarifa de {{fee}} centavos",
        'i_have_coupon': "Tengo un código de cupón",
        "transactionNotCompleted": "Lo sentimos, pero la transacción no se completó para\n<strong> {{productName}} </strong> número de teléfono móvil\n<strong>+{{internationalCountryCode}} {{mobileNumber}}</strong>,\nen la cantidad de <strong> {{faceValue}} </strong>.",
        "transactionInProcess": "Su transacción para\n<strong>{{productName}}</strong> número de teléfono móvil\n<strong>+{{internationalCountryCode}} {{mobileNumber}}</strong>,\nen la cantidad de <strong>{{faceValue}}</strong>, está en proceso de cumplirse.",
        "transactionPaymentSuspended": `Su transacción para el número de móvil <strong>{productName}</strong>\n<strong> +{{internationalCountryCode}} {mobileNumber}</strong>, en la cantidad de <strong>{{faceValue}}</strong>, aún no se ha completado porque\nel procesador de pagos aún no ha confirmado la recepción de fondos.`,
        "transactionNoCharge": "No se le ha cobrado por este intento de transacción.",
        "supportMessage": "Si tiene alguna pregunta, comuníquese con nosotros a través de la página <a href=\"#/tickets\"> Tickets de soporte </a> o desde el botón de Soporte a continuación.",
        "supportTickets": "Boletos de soporte",
        "checkMobileNumber": "Verifique el número de móvil y el operador y vuelva a intentarlo.",
        'dataPlanAlreadyActive': "Lo sentimos, esta transacción no se puede completar porque el plan de datos ya está activado y no ha expirado.",
        "notificationEmail": "Se envió un correo electrónico de notificación a <strong> {{userEmail}} </strong>.\nAnote el número de transacción <strong> {{transactionId}} </strong> para futuras referencias.",
        "customerServiceDilligent": "Nuestro equipo de Atención al Cliente está trabajando diligentemente para cumplir con esta transacción y puede contactarlo para su verificación.\nNo se le cobrará hasta que la transacción se complete con éxito.",
        "customerServicePaymentProcessor": "Nuestro Equipo de Atención al Cliente está trabajando diligentemente con el procesador de pagos para garantizar la finalización.\nSe le notificará tan pronto como se complete la transacción.",
        "notify": "Le notificaremos cuando se complete la transacción.",
        'net_charge': "Carga neta",
        'topup-timeout': "Tiempo de espera de recarga",
        'topup-timeout-msg-1': "Lo sentimos. Lamentablemente, la conexión se agotó. Por favor espere.",
        'topup-timeout-msg-2': "Estamos tratando de contactar al servidor. Tenga la seguridad de que si la transacción no tiene éxito, no se le cobrará por la transacción.",
        'topup-timeout-msg-3': "Una vez que recibamos una respuesta del servidor, le redirigiremos al recibo de su transacción.",
        'topup-timeout-msg-4': "Redirigir en menos de <strong>{{secondsLeft}} Segundos</strong>",
        'amount_charged': "Cantidad cargada",
        'from_paypal': "a PayPal",
        'from_cc': "a la tarjeta",
        'deliver_to': "Entregar a",
        'delivery_email' : "Correo electrónico",
        'delivery_mobile' : "Móvil",
        'delivery_message' : "Mensaje",
        'resend_email' : "Reenviar correo electrónico",
        'amount' : "Monto",
        "transactionNotCompleted_giftcard": `Lo sentimos, pero la transacción no se completó para la tarjeta de regalo de <strong> {{productName}} </strong>, por un monto de <strong> {{faceValue}} </strong>.`,
        'transactionInProcess_giftcard': `Su transacción de tarjeta de regalo de <strong> {{productName}} </strong>, por un monto de <strong> {{faceValue}} </strong>, está en proceso de completarse.`,
        'guest_email_address' : "Dirección de correo electrónico de invitado"
    },
    "support": {
        "signup_button": "Regístrese desde bp",
        "email_alert_msg": "Envíenos un correo electrónico a {{supportEmail}}",
        "email_us_button_title": "Envíanos un correo electrónico",
        "chat_button_title": "Charla"
    },
    "constants": {
        "welcome": "Bienvenido a eTopup Online",
        "exit_app": "¿Quieres salir de la aplicación?",
        "auth_failed": "Autenticación fallida o cancelada",
        "network_error": "Error de red. Por favor, compruebe su conexión a Internet y vuelva a intentarlo.",
        "payment_network_error": "Debido a un error de red, el sistema no puede encontrar el estado de su recarga. Por favor, vaya a la página de inicio. Si se procesa su recarga, verá en la parte superior de la pantalla.",
        "auto_profile_network_error": "Debido a un error de red, el sistema no puede encontrar el estado de su perfil. Por favor, vaya a la página de inicio. Si su perfil es procesado, lo verá en la página de Inicio.",
        "general_network_error": "Se produjo un error de red. Inténtalo de nuevo.",
        "empty_balance_history_msg": "Gracias por elegir eTopupOnline.com. ¡Comienza a enviar recargas y crea historial!",
        "enter_number_for_balance": "Ingrese el número que desea agregar Recarga",
        "no_network_message": "El dispositivo no está conectado a internet. Por favor, corrija la conexión a Internet y presione RECARGAR para continuar",
        "selecte_provider": "Por favor seleccione su proveedor para proceder",
        "exclusive": "Exclusivo",
        "online_offer": "Oferta en línea",
        "loading_msg": "Cargando. Por favor espera...",
        "check_app_version_msg": "Comprobando la versión de la aplicación",
        "app_update_message": "¡Actualización de la aplicación! ',' Se ha lanzado una nueva versión de la aplicación. Debes actualizar tu aplicación",
        "loading_user_settings_msg": "Cargando la configuración del usuario Por favor espera...",
        "loading_recent_trx_msg": "Cargando transacciones y perfiles recientes. Por favor espera...",
        "contact_permissions_title": "Permiso de contacto",
        "contact_permission_message": "La aplicación {{appName}} necesita acceder a tus contactos para que puedas seleccionar el contacto para enviar el saldo."
    },
    "common": {
        "recharge": "Recargar",
        "cancel_button": "Cancelar",
        "cancelled": "Cancelado",
        'active': "Activo",
        'rejected': "Rechazado",
        "ok_button": "DE ACUERDO",
        "sales_tax": "Impuesto de venta",
        "extra": "extra",
        "pay": "Paga",
        "checkout": "Revisa",
        "next": "Siguiente",
        "language": "Idioma",
        "menu": "Menú",
        "close": "Cerrar",
        "ending": "Finalizando",
        "type": "Tipo",
        "question": "Pregunta",
        "issue": "Problema",
        "subject": "Tema",
        "description": "Descripción",
        "submit": "enviar",
        "oops": "Oops..",
        "save": "Salvar",
        "top-up": "Recarga",
        "edit": "Editar",
        "remove": "retirar",
        "select_state": "Seleccione estado",
        "hello": "Hola",
        "policy": "Política",
        "plan": "Plan de datos",
        "new": "Nuevo",
        "notification-subscribe-button" : "Suscribirse a las notificaciones",
        "notification-unsubscribe-button" : "Cancelar la suscripción de notificaciones",
        "notification-text" : "Suscríbase para recibir notificaciones en su teléfono móvil o dispositivo de su preferencia, una vez el estatus de la transacción cambie y notificaciones respecto a nuestras excelentes promociones."
    },
    "error": {
        'validation_error': 'Los datos están incompletos o no son válidos. Por favor corrija los datos antes de proceder',
        "error_mobile_number": "Por favor, corrige el número de teléfono móvil.",
        "error_credit_card": "Por favor, compruebe los detalles de la tarjeta de crédito y vuelva a intentarlo.",
        "user_locked": "El usuario inválido está bloqueado. Por favor, póngase en contacto con soporte al cliente o intente después de un tiempo.",
        "registration_problem": "Hay un problema durante el registro. Inténtalo de nuevo.",
        "error_forgot_password": "La dirección de correo electrónico no está registrada con nosotros. Por favor ingrese una dirección de correo electrónico registrada.",
        "reward_points_limit_error_message": "El monto máximo de canje es {{discount}} {{currency}}",
        "reward_points_min_limit_error_message": "El monto mínimo de canje es {{discount}} {{currency}}",
        "reward_points_invalid_number": "Por favor ingrese un número válido",
        "general_error": "Se produjo un error. Inténtalo de nuevo",
        "error_contact_support": "Lo sentimos. se produjo algún error al realizar esta operación. Por favor, inténtelo de nuevo o contacte a soporte al cliente"
    },
    "messages": {
        "reset_password_email_1": "Hemos enviado un correo electrónico con un enlace para restablecer su contraseña.\nHaga clic en el enlace y se le pedirá que ingrese una nueva contraseña.",
        "reset_password_email_2": "Una vez que haya cambiado la contraseña, puede continuar.",
        "verification_success": "La verificación del código es exitosa. Serás redirigido a la página de inicio de sesión.",
        "code_sent": "El código ha sido enviado exitosamente.",
        "verification_code_sent_1": "Se envió un correo electrónico con un código de verificación a",
        "verification_code_sent_2": "Verifique su correo electrónico (incluidos los filtros de correo no deseado),\nCopie el código en el cuadro siguiente y luego haga clic en el botón 'Verificar'.",
        'different_currency': `Hemos detectado que en el pasado usted realizó transacciónes en {{homeCurrency}}, y la transacción actual está denominada en {{trxCurrency}}. Usted tiene la opción de pagar en {{homeCurrency}}. Por favor, dinos cómo te gustaría proceder`,
        'pay_in_curr': "Pagar en {{currency}}"
    },
    "social": {
        "error_play_service": "Google Play Services no se está ejecutando. saliendo ...",
        "error_google": "Error de Google",
        "sign_in_cancel": "Registrarse cancelado",
        "sign_in_facebook": "Iniciar sesión usando Facebook",
        "sign_in_google": "Inicia sesión con Google"
    },
    "validations": {
        "mobile_number_length": "El número de móvil debe tener {{length}} dígitos de largo",
        'mobile_number_invalid': "Ingrese un número de teléfono móvil válido",
        "user_name_required": "Se requiere nombre de usuario",
        "valid_email": "El nombre de usuario debe ser un correo electrónico válido",
        "password_required": "se requiere contraseña",
        'current_password_required': 'Se requiere contraseña actual',
        "password_char_length": "La contraseña debe tener al menos 6 caracteres de largo",
        "pass_rule_2": "La contraseña debe tener un carácter en minúscula",
        "pass_rule_3": "La contraseña debe tener un carácter en mayúscula",
        "pass_rule_4": "La contraseña debe tener un caracter numérico",
        "password_char_type": "La contraseña debe tener al menos una letra minúscula, una mayúscula y un dígito.",
        'password_message': 'Las contraseñas deben tener al menos 6 caracteres y contener al menos 1 letra mayúscula, 1 letra minúscula y 1 número.',
        "confirm_password": "La contraseña y la contraseña de confirmación deben coincidir",
        "confirm_password_short": "Contraseña debe coincidir con",
        "error_type_validation": "Se produjo un error al validar el token {{type}}",
        "invalid_user_name": "Nombre de usuario no válido.",
        "username_already_taken": "Este nombre de usuario ya está tomado.",
        "invalid_id_pass": "Usuario o contraseña invalido",
        "valid_verification_code": "Por favor ingrese un código válido",
        "invalid_code": "Codigo invalido",
        "credit_card_required_validation": "Se requiere un número de tarjeta de crédito",
        "credit_card_validation": "Por favor ingrese un número de tarjeta de crédito válido",
        "month_required_validation": "Se requiere MM / YY",
        "month_validation": "MM / YY no válido",
        "cvv_required_validation": "Se requiere CVV",
        "cvv_validation": "CVV inválido",
        'select_credit_card': 'Seleccione la tarjeta de crédito',
        "full_name_required": "Nombre completo es requerido",
        "street_address_required": "La dirección de la calle es obligatoria",
        "city_required": "Ciudad es requerida",
        "state_required": "Estado es requerido",
        "country_required": "El país es requerido",
        "zip_required": "El código postal es obligatorio",
        "zip_validation": "Por favor ingrese un código postal / postal válido",
        "required_validation": "{{name}} requiere el nombre",
        "email_validation": "{{name}} debe ser un correo electrónico válido",
        "min_length_validation": "{{name}} debe tener al menos {{length}} carácter de largo",
        "max_length_validation": "{{name}} debe tener menos de {{length}} caracteres de longitud",
        "lower_case_validation": "{{name}} debe tener al menos un carácter en minúscula",
        "upper_case_validation": "{{name}} debe tener al menos un carácter en mayúscula",
        "numeric_validation": "{{name}} debe tener al menos un carácter de tipo numérico",
        "invalid_validation": "{{name}} no es válido",
        "coupon_code_lenght_validation": "El código de cupón debe tener al menos 5 caracteres de largo",
        "coupon_code_validation": "Por favor ingrese un código de cupón válido",
        "coupon_code_applied": "Código de cupón aplicado con éxito",
        "reward_points_applied_success": "Puntos de recompensa aplicados con éxito",
        "reward_points_applied": "¡Felicidades! Está utilizando {{rewardPoints}} puntos para esta recarga. Ahora se le cobrará una cantidad neta de {{netCharge}} {{currency}}.",
        "reward_points_applied_full_amount": "¡Felicidades! Está utilizando {{rewardPoints}} puntos para esta recarga. No se le cobrará por esta transacción.",
        'mobile_number_required': "Se requiere número móvil",
        'operator_required': "El operador es requerido",
        'recipient_mobile_required' : `Se requiere el móvil del destinatario`,
        'recipient_email_required' : `Se requiere el correo electrónico del destinatario`,
        'recipient_name_required' : `Se requiere el nombre completo del destinatario`,
        'sender_name_required' : `Se requiere el nombre completo del remitente`,
        'sender_mobile_required' : `Se requiere el móvil del remitente`,
        'recipient_email_confirm' : 'El email del destinatario y el email de confirmación deben coincidir',
        'enter_valid_recipient_info' : 'Ingrese la información correcta del destinatario y el remitente',
        'guest_email_required' : 'El correo electrónico del invitado de campo es obligatorio',
    },
    "myaccount": {
        "createdOnLabel": "creado en",
        "updatedOnLabel": "actualizado en",
        "statusLabel": "estado",
        "new_contact": "Crear nuevo contacto",
        "edit_contact": "Editar contacto",
        "contact_saved": "Contacto guardado con éxito.",
        "new_comment": "Nuevo comentario",
        "post_comment": "Publica tus comentarios aquí",
        "new_ticket": "Crear nuevo ticket",
        "no_ticket": "Usted no tiene ningún ticket de soporte.",
        "no_auto_topup": "No tienes ninguna recarga automática activa",
        "no_topup": "No tienes ninguna recarga",
        "no_ticket_message": "Si tiene algún problema o pregunta, haga clic <a href='#/ticket/new'>aquí</a> para abrir un nuevo ticket.",
        "error_subject": "Por favor ingrese el asunto",
        "error_description": "Por favor ingrese la descripción",
        "ticket_created": "Su boleto ha sido creado. Nos pondremos en contacto con usted en breve.",
        "comments_posted": "Tu comentario ha sido publicado exitosamente. Nuestro equipo de soporte responderá en breve",
        "ticeket_detail": "Detalle del boleto",
        "delete-auto-topup-confirm-message": "¿Seguro que quieres cancelar la recarga automática?",
        "delete-contact-confirm-message": "¿Seguro que quieres cancelar esta entrada de contacto?",
        "review-history": "Revisar el historial",
        "reward-point-balance-msg": "Tienes {{rewardPointBalance}} puntos de recompensa.",
        "date": "Fecha",
        "points_earned": "Puntos ganados",
        "points_used": "Puntos usados",
        "balance": "Equilibrar",
        "reward_points_policy":"política de puntos de recompensa",
        "delete_stored-card-message" : "¿Seguro que quieres borrar esta tarjeta de crédito?"
    }
}